const getHeading = (mediaType: string) => {
  switch (mediaType) {
    case "print":
      return {
        traffic: "Total Circulation",
        publication: "Articles Published",
      };
    case "digital":
      return {
        publication: "Articles Published",
        traffic: "Total Traffic",
      };
    case "tv":
      return {
        publication: "News Broadcasted",
        traffic: "Total Viewers",
      };
    case "radio":
      return {
        publication: "Episodes Aired",
        traffic: "Total Listeners",
      };
    default:
      return {
        publication: "Total Circulation",
        traffic: "Articles Published",
      };
  }
};

export default getHeading;
